import React from "react";
import { Tooltip } from "antd";
import { Pencil, Trash } from "assets/icons";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../../lobby/styled/index.styled";

interface ICollum {
  title: string;
  dataIndex: string;
  sorter: any;
  filterMultiple: boolean;
  render: (...args) => JSX.Element | string;
  key: string;
  width: string;
}

const ColumnsTable = ({ handleClick, handleClickEdit, isAdmin }) => {
  const DOCUMENT = useTranslation({ id: "document" });
  const ACTIONS = useTranslation({ id: "actions" });
  const EDIT_DOCUMENT = useTranslation({ id: "edit_document" });
  const DELETE_DOCUMENT = useTranslation({ id: "delete_document" });
  const collums: Array<ICollum> = [
    {
      title: DOCUMENT,
      sorter: (a: any, b: any) => {
        a = a.description || "";
        b = b.description || "";
        return a.localeCompare(b);
      },
      filterMultiple: false,
      render: (description: string) => `${description === null || description === "" ? "-" : description}`,
      width: "90%",
      key: "description",
      dataIndex: "description",
    },
  ];

  const actionCollum = {
    title: ACTIONS,
    dataIndex: "action",
    sorter: false,
    filterMultiple: false,
    width: "10%",
    render: (_, record) => (
      <S.ActionContainer quantityItems={2}>
        <button onClick={() => handleClickEdit(record)} data-testid="editItem">
          <Tooltip title={EDIT_DOCUMENT} placement="top">
            <Pencil className="pencilEdit" data-testid="edit-document-icon" />
          </Tooltip>
        </button>
        <button onClick={() => handleClick(record)} data-testid="deleteItem">
          <Tooltip placement="top" title={DELETE_DOCUMENT}>
            <Trash data-testid="delete-document-icon" className="trashIcon" />
          </Tooltip>
        </button>
      </S.ActionContainer>
    ),
    key: "actions",
  };

  if (isAdmin) {
    collums.push(actionCollum);
  }

  return collums;
};

export default ColumnsTable;
